<div class="loader-background"></div>

<div class="loader-container">
    <img src="../../../../assets/images/eCredits-logo-animated.png" width="175" height="158" />
    <!--orig. 700 x 630-->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>
